import type { ReactNode } from "react"

/**
 * Titled inspector section grouping the cards that belong together. Cards stay independent, each owning its own
 * collapse state.
 *
 * Canonical intent: {@link ../intents.ts INSPECTOR_SECTION_INTENT}. Approved surface: APPROVED.md.
 */
const InspectorSection = ({ title, children }: { title: string; children: ReactNode }) => (
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2 px-1">
      <span className="label-base text-fg-base">{title}</span>
    </div>
    <div className="flex flex-col gap-3">{children}</div>
  </div>
)

export default InspectorSection
